"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTileImage = void 0;
const react_1 = __importStar(require("react"));
const product_tile_image_styles_1 = require("./product-tile-image.styles");
const no_image_icon_1 = require("../../../../icons/svg/no-image-icon");
const localization_1 = require("../../../../localization");
const ProductTileImage = ({ image, includeText = true }) => {
    const [imageError, setImageError] = (0, react_1.useState)(!image);
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    return (react_1.default.createElement(product_tile_image_styles_1.StyledImageWrapper, null, !imageError
        && react_1.default.createElement("img", { alt: "product tile", loading: "lazy", src: image, onError: () => setImageError(true) }), imageError
        && (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(no_image_icon_1.NoImageIcon, null), includeText && react_1.default.createElement("span", null, t({ key: 'PRODUCT_TILE_NO_IMAGE_AVAILABLE' }))))));
};
exports.ProductTileImage = ProductTileImage;
